(function ($) {
    $(document).on('click', 'a[href^="#"]', function (e) {
        const $link = $(this);
        const targetId = $link.attr('href');
        const $target = $(targetId);
        const $header = $('#site-header');

        if ($target.length) {
            e.preventDefault();

            // Handle modals separately
            if ($target.hasClass('modal')) {
                $target.modal('toggle');
                return;
            }

            let headerHeight = $header.outerHeight(true);

            // Scroll to adjusted position
            const scrollPos = $target.offset().top - headerHeight - 4;

            $('html, body').animate(
                { scrollTop: scrollPos },
                500,
                function () {
                    // Accessibility focus handling
                    $target.attr('tabindex', '-1').focus();
                }
            );
        }
    });
})(jQuery);
